import ArticleCardMini from './ArticleCardMini';
export default ArticleCardMini;
